export const notificationLogs = {
  name: 'Notification Log |||| Notification Logs',
  fields: {
    id: 'ID',
    type: 'Type',
    recipient_id: 'Recipient ID',
    recipient_type: 'Recipient Type',
    recipient: 'Recipient',
    channel: 'Channel',
    status: 'Status',
    template: 'Template',
    language: 'Language',
    data: 'Data',
    error: 'Error',
    retry_count: 'Retry Count',
    sent_at: 'Sent At',
    delivered_at: 'Delivered At',
    created_at: 'Created At',
    actions: 'Actions',
    notification: 'Notification',
    details: 'Details',
  },
  list: {
    title: 'Notification Logs',
    empty: 'No notification logs found',
    filters: {
      search: 'Search by ID, template, or type',
      status: 'Status',
      channel: 'Channel',
      recipient_type: 'Recipient Type',
      type: 'Notification Type',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
  },
  show: {
    title: 'Notification Log Details',
    tabs: {
      details: 'Details',
      data: 'Data',
      error: 'Error',
    },
    sections: {
      status: 'Status Information',
      recipient: 'Recipient Information',
      timestamps: 'Timestamps',
      error: 'Error Information',
      data: 'Notification Data',
    },
  },
  actions: {
    retry: 'Retry',
    export: 'Export',
    view_details: 'View Details',
  },
  status: {
    queued: 'Queued',
    sending: 'Sending',
    sent: 'Sent',
    delivered: 'Delivered',
    failed: 'Failed',
    bounced: 'Bounced',
  },
  channels: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    push: 'Push Notification',
    slack: 'Slack',
  },
  recipient_types: {
    app_user: 'App User',
    backend_user: 'Backend User',
    external: 'External',
  },
  messages: {
    retry_success: 'Notification queued for retry',
    retry_error: 'Failed to retry notification',
    export_success: 'Logs exported successfully',
    export_error: 'Failed to export logs',
  },
  permissions: {
    no_access: 'You do not have permission to view notification logs',
    read_only: 'You have read-only access to notification logs',
  },
  details: {
    noDetails: 'No details available',
    retries: '%{count} retries',
  },
};